module.exports = __webpack_public_path__ + "static/media/SideScroller.a3e5653c.mp4";